module.exports = __webpack_public_path__ + "img/216-england.5e81b715.svg";